// Status of a finding's issues with Alert Vault: alerts without a sub-task
// are "To Do"; the rest are counted by their Jira status.
export const findingTicketStatusCounts = (
  openAlerts: number,
  subtasks: { status?: string; external_id?: string }[],
) => {
  const ticketed = subtasks.filter(t => t.external_id);
  const counts: Record<string, number> = {};
  const untracked = Math.max(openAlerts - ticketed.length, 0);
  if (untracked > 0) counts['To Do'] = untracked;
  ticketed.forEach(t => {
    const status = t.status || 'To Do';
    counts[status] = (counts[status] ?? 0) + 1;
  });
  return counts;
};
